export default __webpack_public_path__ + "static/media/african4.59f8a05b.jpg";